import React, { useState } from 'react';

function SessionForm(props) {
  const [email, setEmail] = useState("");

  const padEnter = () => (!!email?submitRegistration():void(0))

  const submitRegistration = () => {
    props.onEnter(email)
    var init = { method: 'POST',
               mode: 'cors',
               cache: 'default',
               body: JSON.stringify({
                 "email": email,
                 "mission": props.mission
            }) };
    fetch("https://escape.funatmdf.click/register", init)
      .then(res => res.json())
      .then(
        (result) => {
          console.log("result: " + JSON.stringify(result))
        },
        (error) => {
          console.log("error: " + error)
        }
      )
  }

  const handleKeyPress = (event) => {
    if(event.key === 'Enter'){
        event.preventDefault();
        padEnter()
    }
  }
  return (
    <div id="pinpad">
        <form data-bitwarden-watching="1" onKeyPress={handleKeyPress}>
          <h3>Enter your mdf email</h3>
          <input type="text" id="email" defaultValue="" onChange={(e) => setEmail(e.target.value)} className="pinText"/><br/>
          <input type="button" value="enter" onClick={() => padEnter()} className="pinButton enter"/>
        </form>
    </div>
  );
}

export default SessionForm;